<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('base.dc.dcNo')" prop="dcNo">
                <el-input v-model="queryCondition.dcNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.dc.dcName')" prop="dcName">
                <el-input v-model="queryCondition.dcName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.dc.dcStatus')" prop="status">
                <el-select v-model="queryCondition.status" :disabled="disabledStatusFlag">
                  <el-option :label="$t('common.all')" value=""></el-option>
                  <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <el-table sortable max-height="435" :data="dcList" ref="dcDataTable" border highlight-current-row class="table" :row-key="getRowKeys" @selection-change="handleSelectionChange">
        <el-table-column align="center" v-if="multipleSelectionFlag" prop="tmDcId" type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column align="center" v-else width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmDcId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="dcNo" :label="$t('base.dc.dcNo')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="dcName" :label="$t('base.dc.dcName')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" :label="$t('base.dc.dcStatus')" v-if="showStatus"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { dcService } from "../../../api/base-data/dc";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils"

import { Message } from "element-ui";
export default {
  name: 'dc-sel-page',
  props: {
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    disabledStatusFlag: {
      type: Boolean,
      default: true
    },
    type: {
      type: Array,
      default: new Array("DC")//接受参数xxx;xxxx
    },
    showFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      totalCount: 0,
      dcList: [],
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        dcNo: "",
        dcName: "",
        status: "1",
        types: this.type
      },
      statusList: [],
      multipleSelection: [],
      getRowKeys(row) {
        return row.tmDcId;
      },
      selectRows: [],
      radioVal: null
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
    this.$refs.dcDataTable.clearSelection();
  },
  mounted() {
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      dcService.getDcData(this.queryCondition, this.module).then((res) => {
        this.dcList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    restQueryForm() {
      this.$refs.dcDataTable.clearSelection()
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.radioVal = ""
      this.queryData()
    },
    // 选择
    clickSelectMethod: function () {
      if (this.selectRows.length == 0) {
        Message({ message: "请选择到货仓库(DC)", type: "warning" });
      } else {
        this.$emit('subCallMethod', this.selectRows);
        this.restQueryForm()
      }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.statusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    },
    cancelSeleted: function () {
      this.radioVal = null;
      this.selectRows = [];
    }
  },
  watch: {
    showFlag(val) {
      this.$refs.dcDataTable.clearSelection();
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.handle-input {
  width: 95%;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
